export enum TimelineType {
  TIMELINE_SUMMARY,
  TIMELINE_REALTIME,
  TIMELINE_EXAMINATION,
}
